import { ChartTriggersServiceInterface } from './ChartTriggersServiceInterface'

export abstract class AbstractChartTriggersSerivice implements ChartTriggersServiceInterface {
  protected builderId: string

  constructor(builderId: string) {
    this.builderId = builderId
  }

  abstract selectTrigger(triggerId: string): Promise<void>

  abstract createTrigger(source?: string): Promise<void>
}
